import { render, staticRenderFns } from "./Egresos.vue?vue&type=template&id=61e3b8fe&scoped=true"
import script from "./Egresos.vue?vue&type=script&lang=js"
export * from "./Egresos.vue?vue&type=script&lang=js"
import style0 from "./Egresos.vue?vue&type=style&index=0&id=61e3b8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3b8fe",
  null
  
)

export default component.exports